import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { concatMap, Observable, range, reduce, startWith, switchMap } from 'rxjs';
import { RequestPaginate, RequestService } from './request.service';


@Injectable({
  providedIn: 'root'
})
export class WordpressService extends RequestService {

	constructor(http: HttpClient) { super(http); }

	all (endPoint: string, params?: any): Observable<any> {
		return this.get(endPoint, {params, observe: 'response'}).pipe(
			switchMap(({headers, body}) => 
				range(2, Number(headers.get('x-wp-totalpages')) -1).pipe(
					concatMap(page => this.get(endPoint, {params: {page, ...params}})),
					startWith(body)
				)
			),
			reduce((acc, response) => acc.concat(response), [])
		);
	}

	paginate (endPoint: string, params?: any): WpPaginate {
		return new WpPaginate(this, endPoint, params);
	}
}

export class WpPaginate extends RequestPaginate<any[]> {

	constructor (requestService: WordpressService, endPoint: string, params: any = {}) {
		super(requestService, endPoint, params);
	}

	request () { return this.requestService.get(this.endPoint, {params: this.params.params, observe: 'response'}) }

	protected onRequestSuccess (page): void { 
		this.current.current_page = +this.params.value.page;
		this.current.last_page = +page.headers.get('x-wp-totalpages');
		this.current.total = +page.headers.get('x-wp-total');
		this.state.loading = false;
		this.onPageSubject.next(page.body);
	}
}